"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceConst = (function () {
    function ServiceConst() {
    }
    ServiceConst.HEADER_TOKEN_KEY = 'csrf-token';
    ServiceConst.HEADER_TOKEN_XSRF_KEY = 'xsrf-token';
    ServiceConst.HEADER_TOKEN_X_CSRF_KEY = 'x-csrf-token';
    ServiceConst.HEADER_TOKEN_X_XSRF_KEY = 'x-xsrf-token';
    ServiceConst.HEADER_SERVER_FLAG = 'x-server-flag';
    ServiceConst.HEADER_TRACE_ID = 'x-trace-id';
    ServiceConst.HEADER_CLIENT_START_TIME = 'x-client-start-time';
    ServiceConst.HEADER_CLIENT_END_TIME = 'x-client-end-time';
    ServiceConst.HEADER_X_PORT = 'X-p';
    ServiceConst.HEADER_PARENT = 'x-parent';
    ServiceConst.HEADER_CSRF_KEY = '_csrf';
    ServiceConst.HEADER_SEC_CSRF_KEY = '_secCsrfValue';
    ServiceConst.ONE_WEEK_TIME = 604800000;
    ServiceConst.SERVER_MODE = 'server';
    ServiceConst.CLIENT_MODE = 'client';
    ServiceConst.GET = 'GET';
    ServiceConst.POST = 'POST';
    ServiceConst.PUT = 'PUT';
    ServiceConst.DELETE = 'DELETE';
    ServiceConst.HEAD = 'HEAD';
    ServiceConst.OPTIONS = 'OPTIONS';
    ServiceConst.PATCH = 'PATCH';
    return ServiceConst;
}());
exports.ServiceConst = ServiceConst;
//# sourceMappingURL=ConstService.js.map